import { render, staticRenderFns } from "./ManageSurvey.vue?vue&type=template&id=b9825db2&scoped=true&"
import script from "./ManageSurvey.vue?vue&type=script&lang=js&"
export * from "./ManageSurvey.vue?vue&type=script&lang=js&"
import style0 from "./ManageSurvey.vue?vue&type=style&index=0&id=b9825db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9825db2",
  null
  
)

export default component.exports